// extracted by mini-css-extract-plugin
module.exports = {"checkboxInput":"CheckboxInput_checkboxInput__29U39"};